<template>
	<popup-dialog v-model="model" @close="$emit('close')">
		<game-more-settings-form
			v-if="model"
			@close="$emit('close')"
			slot="content"
			@save="jsonSaved"
		/>
	</popup-dialog>
</template>

<script>
import GameMoreSettingsForm from "dev/view/games/GameMoreSettingsForm";

export default {
	name: "game-more-settings-modal",
	props: [],
	components: {
		GameMoreSettingsForm
	},
	data() {
		return {};
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	},
	methods: {
		jsonSaved(data) {
			this.$emit("save", data);
		}
	},
	created() {},
	mounted() {},
	updated() {},
	destroyed() {}
};
</script>

<style scoped></style>
